// extracted by css-extract-rspack-plugin
export default {"container":"LeadingContent-module__container__X8JPb"};